import { render, staticRenderFns } from "./ContactData.vue?vue&type=template&id=72a40b66&scoped=true&"
import script from "./ContactData.vue?vue&type=script&lang=js&"
export * from "./ContactData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a40b66",
  null
  
)

export default component.exports